var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.53 2.47a.75.75 0 0 0-1.06 1.06zM17 12l.53.53a.75.75 0 0 0 0-1.06zm-9.53 8.47a.75.75 0 1 0 1.06 1.06zm0-16.94 9 9 1.06-1.06-9-9zm9 7.94-9 9 1.06 1.06 9-9z"
})));
export default SvgCaretRight;